/* The DDIR origins allowed to frame the tachograph workspace and talk to it
   by postMessage (theme, Ask Andre). ONE list for every bridge: two lists
   drift, and a host missing from one is a half-working embed. Exact match
   only: no suffix or substring test (ddir.co.uk.evil.test is not DDIR). */
export const DDIR_ORIGINS = Object.freeze([
  'https://ddir.co.uk', 'https://www.ddir.co.uk',
  'https://ddir-app-new.web.app', 'https://ddir-app-new.firebaseapp.com',
  'https://ddir-app-staging.web.app',
  'https://ddir-app-staging.firebaseapp.com',
]);

const ALLOWED = new Set(DDIR_ORIGINS);

/** True when `origin` is exactly one of DDIR_ORIGINS. */
export function isDdirOrigin(origin) {
  return ALLOWED.has(origin);
}

/** Dev only: a message from this page's own loopback origin (the local
    design preview hosts itself). Never true outside `dev`. */
export function isLocalPreviewOrigin(origin, ownOrigin, dev = false) {
  return Boolean(dev) && /^http:\/\/(localhost|127\.0\.0\.1):\d+$/.test(ownOrigin) && origin === ownOrigin;
}
